module.exports = __webpack_public_path__ + "static/media/whiteTrash.d4fc94c8.svg";